/**
 * Generated by orval v6.25.0 🍺
 * Do not edit manually.
 * server-doc
 * Dealkit server
 * OpenAPI spec version: 1.x.x
 */
import axios from "axios";
import type { AxiosRequestConfig, AxiosResponse } from "axios";
export type GetPersonsByOrganizationParams = {
  search?: string;
};

export type GetDealSignaturePacketDownloadPDFForUser404 = {
  reason: string;
};

export type GetDealSignaturePacketDownloadPDFForUser200 = {};

export type GetDealSignaturesForUser404 = {
  reason: string;
};

export type GetDealSignatures404 = {
  reason: string;
};

export type SendDealSignatureRequest404 = {
  reason: string;
};

export type SendDealSignatureRequestParams = {
  reminder?: boolean;
  documentIds?: string;
};

export type RemoveDealInvestorMember404 = {
  reason: string;
};

export type RemoveDealInvestorMember204 = {};

export type AddExistingPersonAsDealInvestorMember404 = {
  reason: string;
};

export type AddNewPersonAsDealInvestorMember404 = {
  reason: string;
};

export type GetDealInvestorMembers404 = {
  reason: string;
};

export type DeleteDealLegalEntityInvestment404 = {
  reason: string;
};

export type DeleteDealLegalEntityInvestment204 = {};

export type UpdateDealLegalEntityInvestment404 = {
  reason: string;
};

export type CreateDealLegalEntityInvestment404 = {
  reason: string;
};

export type GetDealInvestorDealLegalEntityInvestments404 = {
  reason: string;
};

export type UpdateDealInvestor404 = {
  reason: string;
};

export type UpdateDealInvestor400 = {
  reason: string;
};

export type GetDealInvestor404 = {
  reason: string;
};

export type CreateDealInvestorWithMember404 = {
  reason: string;
};

export type CreateDealInvestorWithMember401 =
  (typeof CreateDealInvestorWithMember401)[keyof typeof CreateDealInvestorWithMember401];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateDealInvestorWithMember401 = {
  Unauthorized: "Unauthorized",
} as const;

export type GetDealInvestors404 = {
  reason: string;
};

export type RemoveDealDocumentSignature404 = {
  reason: string;
};

export type RemoveDealDocumentSignature204 =
  | (typeof RemoveDealDocumentSignature204)[keyof typeof RemoveDealDocumentSignature204]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RemoveDealDocumentSignature204 = {} as const;

export type UpdateDealDocumentSignature404 = {
  reason: string;
};

export type UpdateDealDocumentSignature401 =
  (typeof UpdateDealDocumentSignature401)[keyof typeof UpdateDealDocumentSignature401];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateDealDocumentSignature401 = {
  Unauthorized: "Unauthorized",
} as const;

export type CreateDealDocumentSignature412 = {
  reason: string;
};

export type CreateDealDocumentSignature409 = {
  reason: string;
};

export type CreateDealDocumentSignature404 = {
  reason: string;
};

export type CreateDealDocumentSignature401 =
  (typeof CreateDealDocumentSignature401)[keyof typeof CreateDealDocumentSignature401];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateDealDocumentSignature401 = {
  Unauthorized: "Unauthorized",
} as const;

export type GetDealDocumentSignatureById404 = {
  reason: string;
};

export type GetDealDocumentSignatureSignaturePage404 = {
  reason: string;
};

export type GetDealDocumentSignatureSignaturePage200 = {};

export type GetDealDocumentSignatureContents404 = {
  reason: string;
};

export type GetDocumentWithSignedSignaturePages503 = {
  reason: string;
};

export type GetDocumentWithSignedSignaturePages404 = {
  reason: string;
};

export type GetDocumentWithSignedSignaturePages200 = {};

export type GetDealDocumentContents503 = {
  reason: string;
};

export type GetDealDocumentContents404 = {
  reason: string;
};

export type GetDealDocumentContents200 = {};

export type DeleteDealDocument409 =
  (typeof DeleteDealDocument409)[keyof typeof DeleteDealDocument409];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteDealDocument409 = {
  Conflict_due_to_constraint_error: "Conflict due to constraint error",
} as const;

export type DeleteDealDocument404 = {
  reason: string;
};

export type DeleteDealDocument401 =
  (typeof DeleteDealDocument401)[keyof typeof DeleteDealDocument401];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteDealDocument401 = {
  Unauthorized: "Unauthorized",
} as const;

export type DeleteDealDocument204 = {};

export type GetDealDocument404 = {
  reason: string;
};

export type GetDealDocument200 = {};

export type UpdateDealDocument404 = {
  reason: string;
};

export type CreateDealDocument503 = {
  reason: string;
};

export type CreateDealDocument404 = {
  reason: string;
};

export type CreateDealDocument401 =
  (typeof CreateDealDocument401)[keyof typeof CreateDealDocument401];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateDealDocument401 = {
  Unauthorized: "Unauthorized",
} as const;

export type CreateDealDocumentBody = {
  documentType: string;
  extension: string;
  file: Blob;
  name: string;
};

export type GetDealDocuments404 = {
  reason: string;
};

export type GetScheduleOfPurchasers404 = {
  reason: string;
};

export type GetScheduleOfPurchasers200 = {};

export type GetDealById404 = {
  reason: string;
};

export type UpdateDeal409 = {
  reason: string;
};

export type UpdateDeal404 = {
  reason: string;
};

export type UpdateDeal401 = (typeof UpdateDeal401)[keyof typeof UpdateDeal401];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateDeal401 = {
  Unauthorized: "Unauthorized",
} as const;

export type CreateDeal404 = {
  reason: string;
};

export type CreateDeal401 = (typeof CreateDeal401)[keyof typeof CreateDeal401];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateDeal401 = {
  Unauthorized: "Unauthorized",
} as const;

export type RemoveDealCompanyMember404 = {
  reason: string;
};

export type RemoveDealCompanyMember401 =
  (typeof RemoveDealCompanyMember401)[keyof typeof RemoveDealCompanyMember401];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RemoveDealCompanyMember401 = {
  Unauthorized: "Unauthorized",
} as const;

export type RemoveDealCompanyMember204 = {};

export type AddExistingPersonAsDealCompanyMember404 = {
  reason: string;
};

export type AddExistingPersonAsDealCompanyMember401 =
  (typeof AddExistingPersonAsDealCompanyMember401)[keyof typeof AddExistingPersonAsDealCompanyMember401];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddExistingPersonAsDealCompanyMember401 = {
  Unauthorized: "Unauthorized",
} as const;

export type AddNewPersonAsDealCompanyMember404 = {
  reason: string;
};

export type AddNewPersonAsDealCompanyMember401 =
  (typeof AddNewPersonAsDealCompanyMember401)[keyof typeof AddNewPersonAsDealCompanyMember401];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddNewPersonAsDealCompanyMember401 = {
  Unauthorized: "Unauthorized",
} as const;

export type GetDealCompanyMembers404 = {
  reason: string;
};

export type UpdateCompany404 = {
  reason: string;
};

export type GetCompany404 = {
  reason: string;
};

export type SendClientInvitationReminder404 = {
  reason: string;
};

export type SendClientInvitationReminder200 = {};

export type CreateLawFirmClient404 = {
  reason: string;
};

export type GetLawFirmClients404 = {
  reason: string;
};

export type CreateDealLawFirmWithMember404 = {
  reason: string;
};

export type GetDealLawFirms404 = {
  reason: string;
};

export type GetDealDocumentDownloadForVersion404 = {
  reason: string;
};

export type GetDealDocumentContentsForVersion404 = {
  reason: string;
};

export type GetDealDocumentVersions404 = {
  reason: string;
};

export type CreateDealDocumentVersion404 = {
  reason: string;
};

export type CreateDealDocumentVersion401 =
  (typeof CreateDealDocumentVersion401)[keyof typeof CreateDealDocumentVersion401];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateDealDocumentVersion401 = {
  Unauthorized: "Unauthorized",
} as const;

export type CreateDealDocumentVersionBody = {
  extension: string;
  file: Blob;
};

export type AddExistingPersonAsCompanyMember404 = {
  reason: string;
};

export type AddExistingPersonAsCompanyMember401 =
  (typeof AddExistingPersonAsCompanyMember401)[keyof typeof AddExistingPersonAsCompanyMember401];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddExistingPersonAsCompanyMember401 = {
  Unauthorized: "Unauthorized",
} as const;

export type AddNewPersonAsCompanyMember404 = {
  reason: string;
};

export type AddNewPersonAsCompanyMember401 =
  (typeof AddNewPersonAsCompanyMember401)[keyof typeof AddNewPersonAsCompanyMember401];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddNewPersonAsCompanyMember401 = {
  Unauthorized: "Unauthorized",
} as const;

export type GetCompanyMembers404 = {
  reason: string;
};

export type CreateSignatureBlockWithContentPreview404 = {
  reason: string;
};

export type CreateSignatureBlockWithContentPreview400 = {
  reason: string;
};

export type UpdateSignatureBlock404 = {
  reason: string;
};

export type UpdateSignatureBlock400Reason =
  (typeof UpdateSignatureBlock400Reason)[keyof typeof UpdateSignatureBlock400Reason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateSignatureBlock400Reason = {
  no_or_invalid_data_provided: "no or invalid data provided",
} as const;

export type UpdateSignatureBlock400 = {
  reason: UpdateSignatureBlock400Reason;
};

export type GetSignatureBlock404 = {
  reason: string;
};

export type UpdateDealLegalEntityForDealAndDealInvestor404 = {
  reason: string;
};

export type CreateDealLegalEntityForDealAndDealInvestor404 = {
  reason: string;
};

export type GetInvestmentDealLegalEntitiesForDealAndDealInvestor404 = {
  reason: string;
};

export type GetDealLegalEntity404 = {
  reason: string;
};

export type GetDealLegalEntitiesForUser404 = {
  reason: string;
};

export type GetDealLegalEntitiesForDeal404 = {
  reason: string;
};

export type UpdateCompanyLawFirmClient404 = {
  reason: string;
};

export type GetCompanyLawFirms404 = {
  reason: string;
};

export type AdminAddNewPersonToOrganization404 = {
  reason: string;
};

export type AdminGetOrganizationPeople404 = {
  reason: string;
};

export type AdminGetOrganization404 = {
  reason: string;
};

export type AdminCreateLawFirm404 = {
  reason: string;
};

export type AdminGetLawFirms404 = {
  reason: string;
};

export interface DealSignatureRequest {
  dealLegalEntityId: number;
}

export interface AddPersonAsDealInvestorMember {
  personId: number;
}

export type DealLegalEntityInvestmentUpdateAllOf = {
  dealInvestorMemberSignerId?: number;
  signatureBlockId?: number;
  wireDateReceived?: string;
};

export type DealLegalEntityInvestmentUpdate =
  PartialDealLegalEntityInvestmentCreate & DealLegalEntityInvestmentUpdateAllOf;

export type DealLegalEntityInvestmentAllOf = {
  dealInvestorMemberSignerId: number;
  investorId: number;
  legalEntityId: number;
  signatureBlock: SignatureBlock;
  signatureBlockId: number;
  signer: DealLegalEntity;
  wireDateReceived: string;
};

export type DealLegalEntityInvestmentType =
  (typeof DealLegalEntityInvestmentType)[keyof typeof DealLegalEntityInvestmentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DealLegalEntityInvestmentType = {
  New_Cash: "New Cash",
  SAFE_Conversion: "SAFE Conversion",
} as const;

/**
 * Make all properties in T optional
 */
export interface PartialDealLegalEntityInvestmentCreate {
  dealInvestorMemberSignerId?: number;
  dealSeriesId?: number;
  discount?: number;
  exactWireAmount?: number;
  name?: string;
  purchaseAmount?: number;
  shares?: number;
  split?: number;
  targetCashInvestment?: number;
  type?: DealLegalEntityInvestmentType;
  valuationCap?: number;
}

export interface DealLegalEntityInvestmentCreate {
  dealInvestorMemberSignerId?: number;
  dealSeriesId: number;
  discount?: number;
  exactWireAmount?: number;
  name?: string;
  purchaseAmount?: number;
  shares: number;
  split?: number;
  targetCashInvestment?: number;
  type: DealLegalEntityInvestmentType;
  valuationCap?: number;
}

export type DealLegalEntityInvestment = DealLegalEntityInvestmentCreate &
  Identifiable &
  DealLegalEntityInvestmentAllOf;

export interface DealInvestorUpdate {
  city?: string;
  isLead?: boolean;
  line?: string;
  name?: string;
  state?: string;
  targetInvestment?: number;
  zip?: string;
}

export type DealInvestorAllOf = {
  dealId: number;
  investorOrganizationId: number;
};

export type DealInvestorCreateAllOf = {
  isLead: boolean;
  targetInvestment: number;
};

export type DealInvestorCreate = OrganizationCreate & DealInvestorCreateAllOf;

export type DealInvestorAndPersonCreate = DealInvestorCreate & PersonCreate;

export type DealInvestor = Tenanted & DealInvestorCreate & DealInvestorAllOf;

export interface DealDocumentSignatureUpdate {
  id: number;
  status: SigningStatus;
}

export type DealDocumentSignatureWithSignatureContentAllOf = {
  signatureBlockContent: string;
};

export type DealDocumentSignatureAllOfDealLegalEntity = Identifiable &
  DealDocumentSignatureAllOfDealLegalEntityAllOf;

export type DealDocumentSignatureAllOf = {
  dealDocument: DealDocument;
  dealDocumentId: number;
  dealId: number;
  dealLegalEntity: DealDocumentSignatureAllOfDealLegalEntity;
};

export type DealDocumentSignature = Identifiable &
  DealDocumentSignatureCreate &
  DealDocumentSignatureAllOf;

export type DealDocumentSignatureWithSignatureContent = DealDocumentSignature &
  DealDocumentSignatureWithSignatureContentAllOf;

export type DealDocumentSignatureAllOfDealLegalEntityAllOfLegalEntityAllOf = {
  id: number;
  legalEntityType: LegalEntityType;
  name: string;
  organizationId: number;
  personId: number;
};

export type DealDocumentSignatureAllOfDealLegalEntityAllOfLegalEntity =
  Identifiable & DealDocumentSignatureAllOfDealLegalEntityAllOfLegalEntityAllOf;

export type DealDocumentSignatureAllOfDealLegalEntityAllOf = {
  dealId: number;
  id: number;
  isCompany: boolean;
  isInvestor: boolean;
  legalEntity: DealDocumentSignatureAllOfDealLegalEntityAllOfLegalEntity;
  legalEntityId: number;
  legalEntityType: LegalEntityType;
  personId: number;
  roleId: number;
  signatureBlockId: number;
};

export type SigningStatus = (typeof SigningStatus)[keyof typeof SigningStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SigningStatus = {
  notRequested: "notRequested",
  requested: "requested",
  signed: "signed",
} as const;

export interface DealDocumentSignatureCreate {
  dealLegalEntityId: number;
  status: SigningStatus;
}

export interface DealUpdate {
  series?: DealUpdateSeriesItem[];
  seriesOfPreferredStockSold?: string;
  totalRoundSize?: number;
  valuation?: number;
}

export interface CompanyUpdate {
  city?: string;
  line?: string;
  name?: string;
  state?: string;
  zip?: string;
}

export type DealSeriesAllOf = {
  dealId: number;
};

export interface DealSeriesCreate {
  isPrimary: boolean;
  name: string;
  pricePerShare: number;
}

export type DealSeries = Tenanted & DealSeriesCreate & DealSeriesAllOf;

export type DealUpdateSeriesItem = DealSeries | DealSeriesCreate;

export type DealAllOf = {
  companyName: string;
  series: DealSeries[];
};

export interface DealCreate {
  series: DealSeriesCreate[];
  seriesOfPreferredStockSold: string;
  totalRoundSize: number;
  valuation: number;
}

export type Deal = Tenanted & DealCreate & DealAllOf;

export type DealLawFirmAllOf = {
  lawFirm: Organization;
  lawFirmOrganizationId: number;
};

export interface DealLawFirmCreate {
  dealId: number;
}

export type DealLawFirmAndPersonCreate = DealLawFirmCreate &
  OrganizationCreate &
  PersonCreate;

export type DealLawFirm = Tenanted & DealLawFirmCreate & DealLawFirmAllOf;

export type DealDocumentVersionDownloadFormats =
  (typeof DealDocumentVersionDownloadFormats)[keyof typeof DealDocumentVersionDownloadFormats];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DealDocumentVersionDownloadFormats = {
  source: "source",
  pdf: "pdf",
} as const;

export interface DealDocumentBufferWithFileNameAndExtension {
  contents: string;
  fileExtension: string;
  fileName: string;
}

export type DealDocumentVersion = Tenanted & DealDocumentVersionAllOf;

export type DealDocumentVersionAllOfCreatorPerson = {
  createdAt: string;
  email: string;
  firstName: string;
  id: number;
  lastName: string;
  updatedAt: string;
};

export type DealDocumentVersionAllOfCreator = {
  createdAt: string;
  id: number;
  person: DealDocumentVersionAllOfCreatorPerson;
  updatedAt: string;
  verified: boolean;
};

export type AllowedDocumentUploadExtensions =
  (typeof AllowedDocumentUploadExtensions)[keyof typeof AllowedDocumentUploadExtensions];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AllowedDocumentUploadExtensions = {
  docx: "docx",
  pdf: "pdf",
} as const;

export type DealDocumentVersionAllOf = {
  creator: DealDocumentVersionAllOfCreator;
  dealDocumentId: number;
  sourceExtension: AllowedDocumentUploadExtensions;
  version: number;
};

export type DealDocument = Tenanted & DealDocumentCreate;

export type DealDocumentType =
  (typeof DealDocumentType)[keyof typeof DealDocumentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DealDocumentType = {
  Certificate_of_Incorporation: "Certificate of Incorporation",
  Filed_Certificate_of_Incorporation: "Filed Certificate of Incorporation",
  Stock_Purchase_Agreement: "Stock Purchase Agreement",
  "Investors'_Rights_Agreement": "Investors' Rights Agreement",
  Voting_Agreement: "Voting Agreement",
  "Right_of_First_Refusal_and_Co-Sale_Agreement":
    "Right of First Refusal and Co-Sale Agreement",
  Board_Consent: "Board Consent",
  Stockholder_Consent: "Stockholder Consent",
  Compliance_Certificate: "Compliance Certificate",
  "Secretary's_Certificate": "Secretary's Certificate",
  Indemnification_Agreement: "Indemnification Agreement",
  Management_Rights_Letter: "Management Rights Letter",
  Disclosure_Schedule: "Disclosure Schedule",
  Legal_Opinion: "Legal Opinion",
  Opinion_Certificate: "Opinion Certificate",
  Other: "Other",
} as const;

export type DealDocumentCreateAllOf = {
  documentType: DealDocumentType;
  version: number;
};

export interface DealDocumentUpdate {
  name: string;
}

export type DealDocumentCreate = DealDocumentUpdate & DealDocumentCreateAllOf;

export interface AddPersonAsLegalEntity {
  legalEntityType: LegalEntityType;
  personId: number;
}

export type LegalEntityAndPersonCreate = BasicLegalEntityCreate & PersonCreate;

export interface SignatureBlockPreviewData {
  intermediateBy: string;
  intermediateIts: string;
  isEntity: boolean;
  legalEntityName?: string;
  personEmail: string;
  personName: string;
  title: string;
}

export type SignatureBlockWithContentAllOf = {
  content: string;
};

export interface SignatureBlockUpdate {
  dealLegalEntityInvestmentId?: number;
  intermediateBy?: string;
  intermediateIts?: string;
  isEntity?: boolean;
  personIdOfSigner?: number;
  title?: string;
}

export interface SignatureBlockCreate {
  dealLegalEntityInvestmentId?: number;
  intermediateBy?: string;
  intermediateIts?: string;
  isEntity: boolean;
  personIdOfSigner?: number;
  title?: string;
}

export type SignatureBlockWithContent = Identifiable &
  SignatureBlockCreate &
  SignatureBlockWithContentAllOf;

export type SignatureBlock = Identifiable & SignatureBlockCreate;

export interface BasicLegalEntityUpdate {
  name: string;
}

export type DealLegalEntityAllOf = {
  dealId: number;
  isCompany: boolean;
  isInvestor: boolean;
  isLawFirm: boolean;
  legalEntityOrganizationId: number;
};

export type DealLegalEntity = LegalEntity & DealLegalEntityAllOf;

export type LegalEntityAllOf = {
  name: string;
  person: Person;
  personId: number;
};

export interface BasicLegalEntityCreate {
  legalEntityType: LegalEntityType;
  name?: string;
}

export type LegalEntity = Tenanted & BasicLegalEntityCreate & LegalEntityAllOf;

export type LawFirmLegalEntityType =
  (typeof LawFirmLegalEntityType)[keyof typeof LawFirmLegalEntityType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LawFirmLegalEntityType = {
  Company_Counsel: "Company Counsel",
} as const;

export type InvestorLegalEntityType =
  (typeof InvestorLegalEntityType)[keyof typeof InvestorLegalEntityType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvestorLegalEntityType = {
  Investor_Investment: "Investor Investment",
  Investor_Member: "Investor Member",
} as const;

export type CompanyLegalEntityType =
  (typeof CompanyLegalEntityType)[keyof typeof CompanyLegalEntityType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompanyLegalEntityType = {
  Chief_Executive_Officer: "Chief Executive Officer",
  Secretary: "Secretary",
  Board_Member: "Board Member",
  Key_Common_Holder: "Key Common Holder",
  Stockholder: "Stockholder",
  Company_Member: "Company Member",
} as const;

export type LegalEntityType =
  (typeof LegalEntityType)[keyof typeof LegalEntityType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LegalEntityType = {
  ...CompanyLegalEntityType,
  ...InvestorLegalEntityType,
  ...LawFirmLegalEntityType,
} as const;

export interface UpdateLawFirmClient {
  status: UpdateLawFirmClientStatus;
}

export type LawFirmClientStatusDENIED =
  (typeof LawFirmClientStatusDENIED)[keyof typeof LawFirmClientStatusDENIED];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LawFirmClientStatusDENIED = {
  denied: "denied",
} as const;

export type LawFirmClientStatusACCEPTED =
  (typeof LawFirmClientStatusACCEPTED)[keyof typeof LawFirmClientStatusACCEPTED];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LawFirmClientStatusACCEPTED = {
  accepted: "accepted",
} as const;

export type UpdateLawFirmClientStatus =
  (typeof UpdateLawFirmClientStatus)[keyof typeof UpdateLawFirmClientStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateLawFirmClientStatus = {
  ...LawFirmClientStatusACCEPTED,
  ...LawFirmClientStatusDENIED,
} as const;

export type LawFirmClientStatus =
  (typeof LawFirmClientStatus)[keyof typeof LawFirmClientStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LawFirmClientStatus = {
  requested: "requested",
  accepted: "accepted",
  denied: "denied",
} as const;

export type LawFirmClientAllOf = {
  client: Organization;
  clientPersonId: number;
  lawFirm: Organization;
  status: LawFirmClientStatus;
};

export type LawFirmClient = Tenanted & LawFirmClientAllOf;

export interface UserCreate {
  email: string;
  firstName: string;
  lastName: string;
  password?: string;
}

export type CompanyWithAdminUserCreate = OrganizationCreate & UserCreate;

/**
 * From T, pick a set of properties whose keys are in the union K
 */
export interface PickOrganizationExcludeKeyofOrganizationType {
  city?: string;
  createdAt: string;
  id: number;
  line?: string;
  name: string;
  state?: string;
  updatedAt: string;
  zip?: string;
}

export type Company = Tenanted &
  OrganizationCreate &
  PickOrganizationExcludeKeyofOrganizationType;

/**
 * Construct a type with the properties of T except for those in type K.
 */
export type OmitOrganizationType = PickOrganizationExcludeKeyofOrganizationType;

export type CompanyCreate = OrganizationCreate;

export type TenantedAllOf = {
  organizationId: number;
};

export type Tenanted = Identifiable & TenantedAllOf;

export type User = Identifiable & UserAllOf;

export type PersonAllOf = {
  user?: User;
};

export type Person = PersonCreate & Identifiable & PersonAllOf;

export type UserAllOf = {
  person?: Person;
  verified: boolean;
};

export type ValidateErrorJSONMessage =
  (typeof ValidateErrorJSONMessage)[keyof typeof ValidateErrorJSONMessage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ValidateErrorJSONMessage = {
  Validation_failed: "Validation failed",
} as const;

export type ValidateErrorJSONDetailsErrors = { [key: string]: string };

export type ValidateErrorJSONDetails = {
  errors: ValidateErrorJSONDetailsErrors;
};

export interface ValidateErrorJSON {
  details: ValidateErrorJSONDetails;
  message: ValidateErrorJSONMessage;
}

export interface PersonCreate {
  email: string;
  firstName: string;
  lastName: string;
}

export type LawFirmCreate = OrganizationCreate & PersonCreate;

export type OrganizationType =
  (typeof OrganizationType)[keyof typeof OrganizationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationType = {
  Investor: "Investor",
  Company: "Company",
  Law_Firm: "Law Firm",
} as const;

export type OrganizationAllOf = {
  type: OrganizationType;
};

export interface Identifiable {
  createdAt: string;
  id: number;
  updatedAt: string;
}

export interface OrganizationCreate {
  city?: string;
  line?: string;
  name: string;
  state?: string;
  zip?: string;
}

export type Organization = OrganizationCreate &
  Identifiable &
  OrganizationAllOf;

export const adminGetLawFirms = <TData = AxiosResponse<Organization[]>>(
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(`/admin/law-firms`, options);
};

export const adminCreateLawFirm = <TData = AxiosResponse<Organization>>(
  lawFirmCreate: LawFirmCreate,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.post(`/admin/law-firms`, lawFirmCreate, options);
};

export const adminGetOrganization = <TData = AxiosResponse<Organization>>(
  organizationId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(`/admin/organizations/${organizationId}`, options);
};

export const adminGetOrganizationPeople = <TData = AxiosResponse<Person[]>>(
  organizationId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(`/admin/organizations/${organizationId}/people`, options);
};

export const adminAddNewPersonToOrganization = <TData = AxiosResponse<Person>>(
  organizationId: number,
  personCreate: PersonCreate,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.post(
    `/admin/organizations/${organizationId}/people`,
    personCreate,
    options
  );
};

/**
 * Creates a new Company with the Administrative User specified.
 */
export const createCompany = <TData = AxiosResponse<Company>>(
  companyWithAdminUserCreate: CompanyWithAdminUserCreate,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.post(`/companies`, companyWithAdminUserCreate, options);
};

export const getCompanyLawFirms = <TData = AxiosResponse<LawFirmClient[]>>(
  companyOrganizationId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(
    `/companies/${companyOrganizationId}/law-firm-clients`,
    options
  );
};

export const updateCompanyLawFirmClient = <
  TData = AxiosResponse<LawFirmClient>
>(
  companyOrganizationId: number,
  lawFirmClientId: number,
  updateLawFirmClient: UpdateLawFirmClient,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.patch(
    `/companies/${companyOrganizationId}/law-firm-clients/${lawFirmClientId}`,
    updateLawFirmClient,
    options
  );
};

export const getDealLegalEntitiesForDeal = <
  TData = AxiosResponse<DealLegalEntity[]>
>(
  organizationId: number,
  dealId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(
    `/organizations/${organizationId}/deals/${dealId}/legal-entities`,
    options
  );
};

export const getDealLegalEntitiesForUser = <
  TData = AxiosResponse<DealLegalEntity[]>
>(
  organizationId: number,
  dealId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(
    `/organizations/${organizationId}/deals/${dealId}/legal-entities/for-user`,
    options
  );
};

export const getDealLegalEntity = <TData = AxiosResponse<DealLegalEntity>>(
  organizationId: number,
  dealId: number,
  dealLegalEntityId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(
    `/organizations/${organizationId}/deals/${dealId}/legal-entities/${dealLegalEntityId}`,
    options
  );
};

export const getInvestmentDealLegalEntitiesForDealAndDealInvestor = <
  TData = AxiosResponse<DealLegalEntity[]>
>(
  organizationId: number,
  dealId: number,
  dealInvestorId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(
    `/organizations/${organizationId}/deals/${dealId}/investors/${dealInvestorId}/legal-entities`,
    options
  );
};

export const createDealLegalEntityForDealAndDealInvestor = <
  TData = AxiosResponse<DealLegalEntity>
>(
  organizationId: number,
  dealId: number,
  dealInvestorId: number,
  basicLegalEntityCreate: BasicLegalEntityCreate,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.post(
    `/organizations/${organizationId}/deals/${dealId}/investors/${dealInvestorId}/legal-entities`,
    basicLegalEntityCreate,
    options
  );
};

export const updateDealLegalEntityForDealAndDealInvestor = <
  TData = AxiosResponse<DealLegalEntity>
>(
  organizationId: number,
  dealId: number,
  dealInvestorId: number,
  dealLegalEntityId: number,
  basicLegalEntityUpdate: BasicLegalEntityUpdate,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.patch(
    `/organizations/${organizationId}/deals/${dealId}/investors/${dealInvestorId}/legal-entities/${dealLegalEntityId}`,
    basicLegalEntityUpdate,
    options
  );
};

export const getSignatureBlock = <TData = AxiosResponse<SignatureBlock>>(
  organizationId: number,
  dealId: number,
  dealLegalEntityId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(
    `/organizations/${organizationId}/deals/${dealId}/legal-entities/${dealLegalEntityId}/signature-block`,
    options
  );
};

export const updateSignatureBlock = <TData = AxiosResponse<SignatureBlock>>(
  organizationId: number,
  dealId: number,
  dealLegalEntityId: number,
  signatureBlockUpdate: SignatureBlockUpdate,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.patch(
    `/organizations/${organizationId}/deals/${dealId}/legal-entities/${dealLegalEntityId}/signature-block`,
    signatureBlockUpdate,
    options
  );
};

export const createSignatureBlockWithContentPreview = <
  TData = AxiosResponse<SignatureBlockWithContent>
>(
  organizationId: number,
  dealId: number,
  dealLegalEntityId: number,
  signatureBlockPreviewData: SignatureBlockPreviewData,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.post(
    `/organizations/${organizationId}/deals/${dealId}/legal-entities/${dealLegalEntityId}/signature-block-preview`,
    signatureBlockPreviewData,
    options
  );
};

/**
 * Returns the Company Members that belongs to the provided Organization.
 */
export const getCompanyMembers = <TData = AxiosResponse<LegalEntity[]>>(
  organizationId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(`/organizations/${organizationId}/company/members`, options);
};

/**
 * Add a new Person as a member of the Company for this Organization.
 */
export const addNewPersonAsCompanyMember = <TData = AxiosResponse<LegalEntity>>(
  organizationId: number,
  legalEntityAndPersonCreate: LegalEntityAndPersonCreate,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.post(
    `/organizations/${organizationId}/company/members`,
    legalEntityAndPersonCreate,
    options
  );
};

export const addExistingPersonAsCompanyMember = <
  TData = AxiosResponse<LegalEntity>
>(
  organizationId: number,
  addPersonAsLegalEntity: AddPersonAsLegalEntity,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.put(
    `/organizations/${organizationId}/company/members`,
    addPersonAsLegalEntity,
    options
  );
};

export const createDealDocumentVersion = <TData = AxiosResponse<DealDocument>>(
  organizationId: number,
  dealId: number,
  documentId: number,
  createDealDocumentVersionBody: CreateDealDocumentVersionBody,
  options?: AxiosRequestConfig
): Promise<TData> => {
  const formData = new FormData();
  formData.append("extension", createDealDocumentVersionBody.extension);
  formData.append("file", createDealDocumentVersionBody.file);

  return axios.post(
    `/organizations/${organizationId}/deals/${dealId}/documents/${documentId}/versions`,
    formData,
    options
  );
};

export const getDealDocumentVersions = <
  TData = AxiosResponse<DealDocumentVersion[]>
>(
  organizationId: number,
  dealId: number,
  documentId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(
    `/organizations/${organizationId}/deals/${dealId}/documents/${documentId}/versions`,
    options
  );
};

export const getDealDocumentContentsForVersion = <
  TData = AxiosResponse<string>
>(
  organizationId: number,
  dealId: number,
  documentId: number,
  versionNumber: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(
    `/organizations/${organizationId}/deals/${dealId}/documents/${documentId}/versions/${versionNumber}/contents`,
    options
  );
};

export const getDealDocumentDownloadForVersion = <
  TData = AxiosResponse<DealDocumentBufferWithFileNameAndExtension>
>(
  organizationId: number,
  dealId: number,
  documentId: number,
  versionNumber: number,
  format: DealDocumentVersionDownloadFormats,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(
    `/organizations/${organizationId}/deals/${dealId}/documents/${documentId}/versions/${versionNumber}/download/${format}`,
    options
  );
};

export const getDealLawFirms = <TData = AxiosResponse<DealLawFirm[]>>(
  organizationId: number,
  dealId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(
    `/organizations/${organizationId}/deals/${dealId}/law-firms`,
    options
  );
};

export const createDealLawFirmWithMember = <TData = AxiosResponse<DealLawFirm>>(
  organizationId: number,
  dealId: number,
  dealLawFirmAndPersonCreate: DealLawFirmAndPersonCreate,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.post(
    `/organizations/${organizationId}/deals/${dealId}/law-firms`,
    dealLawFirmAndPersonCreate,
    options
  );
};

export const getDeals = <TData = AxiosResponse<Deal[]>>(
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(`/deals`, options);
};

export const getLawFirmClients = <TData = AxiosResponse<LawFirmClient[]>>(
  lawFirmOrganizationId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(`/law-firms/${lawFirmOrganizationId}/clients`, options);
};

export const createLawFirmClient = <TData = AxiosResponse<LawFirmClient>>(
  lawFirmOrganizationId: number,
  companyWithAdminUserCreate: CompanyWithAdminUserCreate,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.post(
    `/law-firms/${lawFirmOrganizationId}/clients`,
    companyWithAdminUserCreate,
    options
  );
};

export const sendClientInvitationReminder = <
  TData = AxiosResponse<SendClientInvitationReminder200>
>(
  lawFirmOrganizationId: number,
  lawFirmClientId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.post(
    `/law-firms/${lawFirmOrganizationId}/clients/${lawFirmClientId}/send-reminder`,
    undefined,
    options
  );
};

/**
 * Returns the Company that belongs to the provided Organization.
 */
export const getCompany = <TData = AxiosResponse<Company>>(
  organizationId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(`/organizations/${organizationId}/company`, options);
};

/**
 * Updates the Company that belongs to the provided Organization.
 */
export const updateCompany = <TData = AxiosResponse<Company>>(
  organizationId: number,
  companyUpdate: CompanyUpdate,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.put(
    `/organizations/${organizationId}/company`,
    companyUpdate,
    options
  );
};

export const getDefaultOrganization = <TData = AxiosResponse<Organization>>(
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(`/organizations/default`, options);
};

/**
 * Returns the Company Members that belongs to the provided Deal for the provided Organization.
 */
export const getDealCompanyMembers = <TData = AxiosResponse<DealLegalEntity[]>>(
  organizationId: number,
  dealId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(
    `/organizations/${organizationId}/deals/${dealId}/company-members`,
    options
  );
};

/**
 * Add a new Person as a member of the Company for this Deal.
 */
export const addNewPersonAsDealCompanyMember = <
  TData = AxiosResponse<DealLegalEntity>
>(
  organizationId: number,
  dealId: number,
  legalEntityAndPersonCreate: LegalEntityAndPersonCreate,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.post(
    `/organizations/${organizationId}/deals/${dealId}/company-members`,
    legalEntityAndPersonCreate,
    options
  );
};

export const addExistingPersonAsDealCompanyMember = <
  TData = AxiosResponse<DealLegalEntity>
>(
  organizationId: number,
  dealId: number,
  addPersonAsLegalEntity: AddPersonAsLegalEntity,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.put(
    `/organizations/${organizationId}/deals/${dealId}/company-members`,
    addPersonAsLegalEntity,
    options
  );
};

export const removeDealCompanyMember = <
  TData = AxiosResponse<RemoveDealCompanyMember204>
>(
  organizationId: number,
  dealId: number,
  dealCompanyMemberId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.delete(
    `/organizations/${organizationId}/deals/${dealId}/company-members/${dealCompanyMemberId}`,
    options
  );
};

export const createDeal = <TData = AxiosResponse<Deal>>(
  organizationId: number,
  dealCreate: DealCreate,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.post(
    `/organizations/${organizationId}/deals`,
    dealCreate,
    options
  );
};

export const updateDeal = <TData = AxiosResponse<Deal>>(
  organizationId: number,
  dealId: number,
  dealUpdate: DealUpdate,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.put(
    `/organizations/${organizationId}/deals/${dealId}`,
    dealUpdate,
    options
  );
};

/**
 * Returns the Deal specified by the dealId for the Organization specified by the organizationId.
 */
export const getDealById = <TData = AxiosResponse<Deal>>(
  organizationId: number,
  dealId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(`/organizations/${organizationId}/deals/${dealId}`, options);
};

export const getScheduleOfPurchasers = <
  TData = AxiosResponse<GetScheduleOfPurchasers200>
>(
  organizationId: number,
  dealId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(
    `/organizations/${organizationId}/deals/${dealId}/schedule-of-purchasers.pdf`,
    options
  );
};

export const getDealDocuments = <TData = AxiosResponse<DealDocument[]>>(
  organizationId: number,
  dealId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(
    `/organizations/${organizationId}/deals/${dealId}/documents`,
    options
  );
};

export const createDealDocument = <TData = AxiosResponse<DealDocument[]>>(
  organizationId: number,
  dealId: number,
  createDealDocumentBody: CreateDealDocumentBody,
  options?: AxiosRequestConfig
): Promise<TData> => {
  const formData = new FormData();
  formData.append("name", createDealDocumentBody.name);
  formData.append("extension", createDealDocumentBody.extension);
  formData.append("documentType", createDealDocumentBody.documentType);
  formData.append("file", createDealDocumentBody.file);

  return axios.post(
    `/organizations/${organizationId}/deals/${dealId}/documents`,
    formData,
    options
  );
};

export const updateDealDocument = <TData = AxiosResponse<DealDocument>>(
  organizationId: number,
  dealId: number,
  documentId: number,
  dealDocumentUpdate: DealDocumentUpdate,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.patch(
    `/organizations/${organizationId}/deals/${dealId}/documents/${documentId}`,
    dealDocumentUpdate,
    options
  );
};

export const getDealDocument = <TData = AxiosResponse<GetDealDocument200>>(
  organizationId: number,
  dealId: number,
  documentId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(
    `/organizations/${organizationId}/deals/${dealId}/documents/${documentId}`,
    options
  );
};

export const deleteDealDocument = <
  TData = AxiosResponse<DeleteDealDocument204>
>(
  organizationId: number,
  dealId: number,
  documentId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.delete(
    `/organizations/${organizationId}/deals/${dealId}/documents/${documentId}`,
    options
  );
};

export const getDealDocumentContents = <
  TData = AxiosResponse<GetDealDocumentContents200>
>(
  organizationId: number,
  dealId: number,
  documentId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(
    `/organizations/${organizationId}/deals/${dealId}/documents/${documentId}/contents`,
    options
  );
};

export const getDocumentWithSignedSignaturePages = <
  TData = AxiosResponse<GetDocumentWithSignedSignaturePages200>
>(
  organizationId: number,
  dealId: number,
  dealDocumentId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(
    `/organizations/${organizationId}/deals/${dealId}/documents/${dealDocumentId}/executed-doc.pdf`,
    options
  );
};

/**
 * Returns all the signed signature pages for a given deal document in the given deal.
 */
export const getDealDocumentSignatureContents = <
  TData = AxiosResponse<string[]>
>(
  organizationId: number,
  dealId: number,
  dealDocumentId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(
    `/organizations/${organizationId}/deals/${dealId}/documents/${dealDocumentId}/signatures/signature-contents`,
    options
  );
};

export const getDealDocumentSignatureSignaturePage = <
  TData = AxiosResponse<GetDealDocumentSignatureSignaturePage200>
>(
  organizationId: number,
  dealId: number,
  dealDocumentId: number,
  documentSignatureId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(
    `/organizations/${organizationId}/deals/${dealId}/documents/${dealDocumentId}/signatures/${documentSignatureId}/signature-contents.pdf`,
    options
  );
};

/**
 * Returns the Deal Document Signature specified by the dealSignerId, organizationId, dealId, and documentId
 */
export const getDealDocumentSignatureById = <
  TData = AxiosResponse<DealDocumentSignatureWithSignatureContent>
>(
  organizationId: number,
  dealId: number,
  dealDocumentId: number,
  documentSignatureId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(
    `/organizations/${organizationId}/deals/${dealId}/documents/${dealDocumentId}/signatures/${documentSignatureId}`,
    options
  );
};

/**
 * Create a Person as a Signer for a Document of a Deal.
 */
export const createDealDocumentSignature = <
  TData = AxiosResponse<DealDocumentSignatureWithSignatureContent[]>
>(
  organizationId: number,
  dealId: number,
  dealDocumentId: number,
  dealDocumentSignatureCreate: DealDocumentSignatureCreate[],
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.put(
    `/organizations/${organizationId}/deals/${dealId}/documents/${dealDocumentId}/signatures`,
    dealDocumentSignatureCreate,
    options
  );
};

/**
 * Update a Signature for a Document of a Deal.
 */
export const updateDealDocumentSignature = <
  TData = AxiosResponse<DealDocumentSignatureWithSignatureContent[]>
>(
  organizationId: number,
  dealId: number,
  dealDocumentId: number,
  dealDocumentSignatureUpdate: DealDocumentSignatureUpdate[],
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.patch(
    `/organizations/${organizationId}/deals/${dealId}/documents/${dealDocumentId}/signatures`,
    dealDocumentSignatureUpdate,
    options
  );
};

/**
 * Delete a Signature for a Document of a Deal.
 */
export const removeDealDocumentSignature = <
  TData = AxiosResponse<RemoveDealDocumentSignature204>
>(
  organizationId: number,
  dealId: number,
  dealDocumentId: number,
  removeDealDocumentSignatureBody: number[],
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.delete(
    `/organizations/${organizationId}/deals/${dealId}/documents/${dealDocumentId}/signatures`,
    { data: removeDealDocumentSignatureBody, ...options }
  );
};

export const getDealInvestors = <TData = AxiosResponse<DealInvestor[]>>(
  organizationId: number,
  dealId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(
    `/organizations/${organizationId}/deals/${dealId}/investors`,
    options
  );
};

export const createDealInvestorWithMember = <
  TData = AxiosResponse<DealInvestor>
>(
  organizationId: number,
  dealId: number,
  dealInvestorAndPersonCreate: DealInvestorAndPersonCreate,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.post(
    `/organizations/${organizationId}/deals/${dealId}/investors`,
    dealInvestorAndPersonCreate,
    options
  );
};

export const getDealInvestor = <TData = AxiosResponse<DealInvestor>>(
  organizationId: number,
  dealId: number,
  dealInvestorId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(
    `/organizations/${organizationId}/deals/${dealId}/investors/${dealInvestorId}`,
    options
  );
};

export const updateDealInvestor = <TData = AxiosResponse<DealInvestor>>(
  organizationId: number,
  dealId: number,
  dealInvestorId: number,
  dealInvestorUpdate: DealInvestorUpdate,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.patch(
    `/organizations/${organizationId}/deals/${dealId}/investors/${dealInvestorId}`,
    dealInvestorUpdate,
    options
  );
};

export const getDealInvestorDealLegalEntityInvestments = <
  TData = AxiosResponse<DealLegalEntityInvestment[]>
>(
  organizationId: number,
  dealId: number,
  dealInvestorId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(
    `/organizations/${organizationId}/deals/${dealId}/investors/${dealInvestorId}/investments`,
    options
  );
};

export const createDealLegalEntityInvestment = <
  TData = AxiosResponse<DealLegalEntityInvestment>
>(
  organizationId: number,
  dealId: number,
  dealInvestorId: number,
  dealLegalEntityInvestmentCreate: DealLegalEntityInvestmentCreate,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.post(
    `/organizations/${organizationId}/deals/${dealId}/investors/${dealInvestorId}/investments`,
    dealLegalEntityInvestmentCreate,
    options
  );
};

export const updateDealLegalEntityInvestment = <
  TData = AxiosResponse<DealLegalEntityInvestment>
>(
  organizationId: number,
  dealId: number,
  dealInvestorId: number,
  dealLegalEntityInvestmentId: number,
  dealLegalEntityInvestmentUpdate: DealLegalEntityInvestmentUpdate,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.patch(
    `/organizations/${organizationId}/deals/${dealId}/investors/${dealInvestorId}/investments/${dealLegalEntityInvestmentId}`,
    dealLegalEntityInvestmentUpdate,
    options
  );
};

export const deleteDealLegalEntityInvestment = <
  TData = AxiosResponse<DeleteDealLegalEntityInvestment204>
>(
  organizationId: number,
  dealId: number,
  dealInvestorId: number,
  dealLegalEntityInvestmentId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.delete(
    `/organizations/${organizationId}/deals/${dealId}/investors/${dealInvestorId}/investments/${dealLegalEntityInvestmentId}`,
    options
  );
};

export const getDealInvestorMembers = <
  TData = AxiosResponse<DealLegalEntity[]>
>(
  organizationId: number,
  dealId: number,
  dealInvestorId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(
    `/organizations/${organizationId}/deals/${dealId}/investors/${dealInvestorId}/members`,
    options
  );
};

export const addNewPersonAsDealInvestorMember = <
  TData = AxiosResponse<DealLegalEntity>
>(
  organizationId: number,
  dealId: number,
  dealInvestorId: number,
  personCreate: PersonCreate,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.post(
    `/organizations/${organizationId}/deals/${dealId}/investors/${dealInvestorId}/members`,
    personCreate,
    options
  );
};

export const addExistingPersonAsDealInvestorMember = <
  TData = AxiosResponse<DealLegalEntity>
>(
  organizationId: number,
  dealId: number,
  dealInvestorId: number,
  addPersonAsDealInvestorMember: AddPersonAsDealInvestorMember,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.put(
    `/organizations/${organizationId}/deals/${dealId}/investors/${dealInvestorId}/members`,
    addPersonAsDealInvestorMember,
    options
  );
};

export const removeDealInvestorMember = <
  TData = AxiosResponse<RemoveDealInvestorMember204>
>(
  organizationId: number,
  dealId: number,
  dealInvestorId: number,
  dealInvestorMemberId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.delete(
    `/organizations/${organizationId}/deals/${dealId}/investors/${dealInvestorId}/members/${dealInvestorMemberId}`,
    options
  );
};

/**
 * Send a signature request email for a Deal Company Member or a Deal Investor Member.
 */
export const sendDealSignatureRequest = <
  TData = AxiosResponse<DealDocumentSignature[]>
>(
  organizationId: number,
  dealId: number,
  dealSignatureRequest: DealSignatureRequest,
  params?: SendDealSignatureRequestParams,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.post(
    `/organizations/${organizationId}/deals/${dealId}/signaturerequest`,
    dealSignatureRequest,
    {
      ...options,
      params: { ...params, ...options?.params },
    }
  );
};

/**
 * Returns the Document Signatures for the Deal specified by the dealId and the Organization specified by the organizationId.
 */
export const getDealSignatures = <
  TData = AxiosResponse<DealDocumentSignature[]>
>(
  organizationId: number,
  dealId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(
    `/organizations/${organizationId}/deals/${dealId}/signatures`,
    options
  );
};

/**
 * Returns the Document Signatures assigned to the user specified as userId for the Deal specified by the dealId and
the Organization specified by the organizationId.
 */
export const getDealSignaturesForUser = <
  TData = AxiosResponse<DealDocumentSignature[]>
>(
  organizationId: number,
  dealId: number,
  userId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(
    `/organizations/${organizationId}/deals/${dealId}/signatures/for-user/${userId}`,
    options
  );
};

export const getDealSignaturePacketDownloadPDFForUser = <
  TData = AxiosResponse<GetDealSignaturePacketDownloadPDFForUser200>
>(
  organizationId: number,
  dealId: number,
  personId: number,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(
    `/organizations/${organizationId}/deals/${dealId}/signatures/for-user/${personId}/signature-packet.pdf`,
    options
  );
};

export const getPersonsByOrganization = <TData = AxiosResponse<Person[]>>(
  organizationId: number,
  params?: GetPersonsByOrganizationParams,
  options?: AxiosRequestConfig
): Promise<TData> => {
  return axios.get(`/organizations/${organizationId}/persons`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export type AdminGetLawFirmsResult = AxiosResponse<Organization[]>;
export type AdminCreateLawFirmResult = AxiosResponse<Organization>;
export type AdminGetOrganizationResult = AxiosResponse<Organization>;
export type AdminGetOrganizationPeopleResult = AxiosResponse<Person[]>;
export type AdminAddNewPersonToOrganizationResult = AxiosResponse<Person>;
export type CreateCompanyResult = AxiosResponse<Company>;
export type GetCompanyLawFirmsResult = AxiosResponse<LawFirmClient[]>;
export type UpdateCompanyLawFirmClientResult = AxiosResponse<LawFirmClient>;
export type GetDealLegalEntitiesForDealResult = AxiosResponse<
  DealLegalEntity[]
>;
export type GetDealLegalEntitiesForUserResult = AxiosResponse<
  DealLegalEntity[]
>;
export type GetDealLegalEntityResult = AxiosResponse<DealLegalEntity>;
export type GetInvestmentDealLegalEntitiesForDealAndDealInvestorResult =
  AxiosResponse<DealLegalEntity[]>;
export type CreateDealLegalEntityForDealAndDealInvestorResult =
  AxiosResponse<DealLegalEntity>;
export type UpdateDealLegalEntityForDealAndDealInvestorResult =
  AxiosResponse<DealLegalEntity>;
export type GetSignatureBlockResult = AxiosResponse<SignatureBlock>;
export type UpdateSignatureBlockResult = AxiosResponse<SignatureBlock>;
export type CreateSignatureBlockWithContentPreviewResult =
  AxiosResponse<SignatureBlockWithContent>;
export type GetCompanyMembersResult = AxiosResponse<LegalEntity[]>;
export type AddNewPersonAsCompanyMemberResult = AxiosResponse<LegalEntity>;
export type AddExistingPersonAsCompanyMemberResult = AxiosResponse<LegalEntity>;
export type CreateDealDocumentVersionResult = AxiosResponse<DealDocument>;
export type GetDealDocumentVersionsResult = AxiosResponse<
  DealDocumentVersion[]
>;
export type GetDealDocumentContentsForVersionResult = AxiosResponse<string>;
export type GetDealDocumentDownloadForVersionResult =
  AxiosResponse<DealDocumentBufferWithFileNameAndExtension>;
export type GetDealLawFirmsResult = AxiosResponse<DealLawFirm[]>;
export type CreateDealLawFirmWithMemberResult = AxiosResponse<DealLawFirm>;
export type GetDealsResult = AxiosResponse<Deal[]>;
export type GetLawFirmClientsResult = AxiosResponse<LawFirmClient[]>;
export type CreateLawFirmClientResult = AxiosResponse<LawFirmClient>;
export type SendClientInvitationReminderResult =
  AxiosResponse<SendClientInvitationReminder200>;
export type GetCompanyResult = AxiosResponse<Company>;
export type UpdateCompanyResult = AxiosResponse<Company>;
export type GetDefaultOrganizationResult = AxiosResponse<Organization>;
export type GetDealCompanyMembersResult = AxiosResponse<DealLegalEntity[]>;
export type AddNewPersonAsDealCompanyMemberResult =
  AxiosResponse<DealLegalEntity>;
export type AddExistingPersonAsDealCompanyMemberResult =
  AxiosResponse<DealLegalEntity>;
export type RemoveDealCompanyMemberResult =
  AxiosResponse<RemoveDealCompanyMember204>;
export type CreateDealResult = AxiosResponse<Deal>;
export type UpdateDealResult = AxiosResponse<Deal>;
export type GetDealByIdResult = AxiosResponse<Deal>;
export type GetScheduleOfPurchasersResult =
  AxiosResponse<GetScheduleOfPurchasers200>;
export type GetDealDocumentsResult = AxiosResponse<DealDocument[]>;
export type CreateDealDocumentResult = AxiosResponse<DealDocument[]>;
export type UpdateDealDocumentResult = AxiosResponse<DealDocument>;
export type GetDealDocumentResult = AxiosResponse<GetDealDocument200>;
export type DeleteDealDocumentResult = AxiosResponse<DeleteDealDocument204>;
export type GetDealDocumentContentsResult =
  AxiosResponse<GetDealDocumentContents200>;
export type GetDocumentWithSignedSignaturePagesResult =
  AxiosResponse<GetDocumentWithSignedSignaturePages200>;
export type GetDealDocumentSignatureContentsResult = AxiosResponse<string[]>;
export type GetDealDocumentSignatureSignaturePageResult =
  AxiosResponse<GetDealDocumentSignatureSignaturePage200>;
export type GetDealDocumentSignatureByIdResult =
  AxiosResponse<DealDocumentSignatureWithSignatureContent>;
export type CreateDealDocumentSignatureResult = AxiosResponse<
  DealDocumentSignatureWithSignatureContent[]
>;
export type UpdateDealDocumentSignatureResult = AxiosResponse<
  DealDocumentSignatureWithSignatureContent[]
>;
export type RemoveDealDocumentSignatureResult =
  AxiosResponse<RemoveDealDocumentSignature204>;
export type GetDealInvestorsResult = AxiosResponse<DealInvestor[]>;
export type CreateDealInvestorWithMemberResult = AxiosResponse<DealInvestor>;
export type GetDealInvestorResult = AxiosResponse<DealInvestor>;
export type UpdateDealInvestorResult = AxiosResponse<DealInvestor>;
export type GetDealInvestorDealLegalEntityInvestmentsResult = AxiosResponse<
  DealLegalEntityInvestment[]
>;
export type CreateDealLegalEntityInvestmentResult =
  AxiosResponse<DealLegalEntityInvestment>;
export type UpdateDealLegalEntityInvestmentResult =
  AxiosResponse<DealLegalEntityInvestment>;
export type DeleteDealLegalEntityInvestmentResult =
  AxiosResponse<DeleteDealLegalEntityInvestment204>;
export type GetDealInvestorMembersResult = AxiosResponse<DealLegalEntity[]>;
export type AddNewPersonAsDealInvestorMemberResult =
  AxiosResponse<DealLegalEntity>;
export type AddExistingPersonAsDealInvestorMemberResult =
  AxiosResponse<DealLegalEntity>;
export type RemoveDealInvestorMemberResult =
  AxiosResponse<RemoveDealInvestorMember204>;
export type SendDealSignatureRequestResult = AxiosResponse<
  DealDocumentSignature[]
>;
export type GetDealSignaturesResult = AxiosResponse<DealDocumentSignature[]>;
export type GetDealSignaturesForUserResult = AxiosResponse<
  DealDocumentSignature[]
>;
export type GetDealSignaturePacketDownloadPDFForUserResult =
  AxiosResponse<GetDealSignaturePacketDownloadPDFForUser200>;
export type GetPersonsByOrganizationResult = AxiosResponse<Person[]>;
